/**
 * Bridge between the HTTP client (outside React) and the maintenance takeover (React).
 * On a 503 maintenance response, `httpClient` emits this event; a mounted listener
 * takes over (`preventDefault`) to render the maintenance page instead of surfacing
 * a raw error. Mirrors the `sessionExpiry` 401 bridge.
 */
export const MAINTENANCE_EVENT = 'cse:maintenance'

export type MaintenanceDetail = {
  message?: string | null
  retryAfter?: string | null
}

/** Emits the event. Returns `true` if a listener handled it (`preventDefault`). */
export function emitMaintenanceMode(detail: MaintenanceDetail = {}): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  const event = new CustomEvent<MaintenanceDetail>(MAINTENANCE_EVENT, { cancelable: true, detail })
  window.dispatchEvent(event)
  return event.defaultPrevented
}

/** Subscribes a handler to the maintenance event. Returns the unsubscribe function. */
export function onMaintenanceMode(handler: (event: CustomEvent<MaintenanceDetail>) => void): () => void {
  const listener = handler as EventListener
  window.addEventListener(MAINTENANCE_EVENT, listener)
  return () => window.removeEventListener(MAINTENANCE_EVENT, listener)
}
